import React from 'react';
import SequenceBuilder from './SequenceBuilder';

export function numberSequence(question) {
  if (question?.question_family !== 'order_sequence' || question?.interaction_type !== 'sequence_builder'
    || question?.answer_mode !== 'sequence_builder' || !['ascending', 'descending'].includes(question?.direction)) return null;
  const tokens = question.tokens;
  if (!Array.isArray(tokens) || tokens.length < 3 || tokens.length > 5 || question.slot_count !== tokens.length) return null;
  if (!tokens.every((token) => typeof token.tokenId === 'string' && token.tokenId && typeof token.displayText === 'string' && token.displayText)) return null;
  if (new Set(tokens.map((token) => token.tokenId)).size !== tokens.length) return null;
  return tokens;
}

export default function NumberSequenceAnswer({ tokens, questionKey, disabled, correctTokenOrder, onAnswer }) {
  return <SequenceBuilder tokens={tokens} questionKey={questionKey} disabled={disabled} correctTokenOrder={correctTokenOrder}
    onComplete={(selectedTokenIds) => onAnswer({ selectedTokenIds })} />;
}
